import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    originalWorkflow: {nodes: [], edges: []},
    workflow: {nodes: [], edges: []},
    nodeType: "",
    selectedStep: {},
    selectedConnector: {},
    connectorMenu: "default",
    mergeTargetNode: {},
    conditions: [],
    deletedNodes: [],
    workflowForms: [],
    nodeToBeDeleted: "",
    changeDetected: false, 
    addNodeInBetween: {},
    insertNodeBetween: {},
    showCondition: false,
    sidebarOpen: false,
    sidebarData: {},
    sidebarType: ""
};

const connectorSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setOriginalWorkflow: (state, action) => {
            state.originalWorkflow = action.payload
        }, 
        setWorkflow: (state, action) => {
            state.workflow = action.payload
        }, 
        setNodeType: (state, action) => {
            state.nodeType = action.payload;
        },
        resetNodeType: (state) => {
            state.nodeType = "";
        },
        setSelectedStep: (state, action) => {
            state.selectedStep = action.payload;
        },
        setSelectedConnector: (state, action) => {
            state.selectedConnector = action.payload
        },
        setConnectorMenu: (state, action) => {
            state.connectorMenu = action.payload
        },
        setMergeTargetNode: (state, action) => {
            state.mergeTargetNode = action.payload
        },
        setConditions: (state, action) => {
            state.conditions = action.payload
        },
        setDeletedNodes: (state, action) => {
            state.deletedNodes = state.deletedNodes.concat(action.payload)
        },
        setWorkflowForms: (state, action) => {
            state.workflowForms = action.payload
        },
        setNodeToBeDeleted: (state, action) => {
            state.nodeToBeDeleted = action.payload
        },
        setChangeDetected: (state, action) => {
            state.changeDetected = action.payload
        },
        setAddNodeInBetween: (state, action) => {
            state.addNodeInBetween = action.payload
        },
        setInsertNodeBetween: (state, action) => {
            state.insertNodeBetween = action.payload
        },
        setShowCondition: (state, action) => {
            state.showCondition = action.payload
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload
        },
        setSidebarData: (state, action) => {
            state.sidebarData = action.payload
        },
        setSidebarType: (state, action) => {
            state.sidebarType = action.payload
        }
    }
});

export const { setNodeType, resetNodeType, setSelectedStep, setSelectedConnector, setOriginalWorkflow, setWorkflow, setConnectorMenu, setMergeTargetNode, setConditions, setDeletedNodes, setWorkflowForms, setNodeToBeDeleted, setChangeDetected, setAddNodeInBetween, setInsertNodeBetween, setShowCondition, setSidebarOpen, setSidebarData, setSidebarType} = connectorSlice.actions;

export default connectorSlice.reducer;